import type { LegalCopy } from '../types'

export const bn: LegalCopy = {
  title: 'আইনি সাহায্য',
  subtitle: 'সাধারণ আইনি সমস্যা, সহজ কথায় বোঝানো। নিজের ভাষায় শুনুন, আর প্রতিটি উত্তরের সরকারি সূত্র দেখুন।',
  helplinesTitle: 'হেল্পলাইন (বিনামূল্যে কল)',
  helplines: {
    emergency: 'জরুরি অবস্থা: পুলিশ, দমকল, অ্যাম্বুলেন্স',
    legal_aid: 'বিনামূল্যে আইনি সাহায্য (NALSA)',
    cyber: 'অনলাইন / UPI প্রতারণা',
    women: 'মহিলা হেল্পলাইন',
    consumer: 'উপভোক্তা (ক্রেতা) হেল্পলাইন'
  },
  faqTitle: 'সাধারণ প্রশ্ন',
  searchPlaceholder: 'খুঁজুন: FIR, প্রতারণা, RTI, উকিল…',
  noMatch: 'কোনো প্রশ্ন মেলেনি। নিচে নিজের প্রশ্ন করুন।',
  sources: 'সরকারি সূত্র',
  listen: 'শুনুন',
  askTitle: 'নিজের আইনি প্রশ্ন করুন',
  askHint: 'সমঝো শুধু সরকারি ওয়েবসাইট থেকে উত্তর দেয়, সূত্রের লিংক সহ।',
  starters: ['আমি কি বিনামূল্যে উকিল পেতে পারি?', 'কেউ অনলাইনে আমাকে ঠকিয়েছে। আমি কী করব?', 'পুলিশ আমার অভিযোগ লিখছে না। আমি কী করতে পারি?'],
  disclaimer:
    'এটি সরকারি সূত্র থেকে নেওয়া সাধারণ তথ্য, আপনার মামলার জন্য আইনি পরামর্শ নয়। নিজের মামলার জন্য উকিলের সঙ্গে কথা বলুন — আইনি পরিষেবা কর্তৃপক্ষ (15100) থেকে বিনামূল্যে উকিল পেতে পারেন।',
  topics: {
    get_free_aid: {
      q: 'বিনামূল্যে আইনি সাহায্য কীভাবে পাব?',
      a: 'NALSA-র বিনামূল্যের হেল্পলাইন 15100 নম্বরে কল করুন। অথবা আপনার জেলা আদালতে আইনি পরিষেবা কর্তৃপক্ষের অফিসে, বা তালুকা আদালতে আইনি পরিষেবা কমিটির কাছে যান। আপনি অনলাইনে, ডাকে বা ই-মেলেও আবেদন করতে পারেন। ফর্ম বিনামূল্যে, আর উকিলের ফি ও আদালতের খরচ আপনার হয়ে দিয়ে দেওয়া হয়।'
    },
    who_free_aid: {
      q: 'বিনামূল্যে উকিল কে পেতে পারেন?',
      a: 'আইন (আইনি পরিষেবা কর্তৃপক্ষ আইনের ধারা 12) এঁদের বিনামূল্যে আইনি সাহায্য দেয়: মহিলা ও শিশু, SC/ST সম্প্রদায়ের মানুষ, প্রতিবন্ধী মানুষ, শিল্প-শ্রমিক, মানব পাচার বা জোর করে খাটানো শ্রমের (বেগার) শিকার, দুর্যোগ, জাতপাতের অত্যাচার বা জাতিগত হিংসার শিকার, হেফাজতে থাকা মানুষ, আর যাঁদের বছরের আয় তাঁদের রাজ্যের ঠিক করা সীমার কম। আয়ের সীমা প্রতিটি রাজ্যে আলাদা।'
    },
    fir: {
      q: 'পুলিশ আমার FIR নিচ্ছে না। আমি কী করব?',
      a: 'গুরুতর (আমলযোগ্য) অপরাধের কথা আপনি যেকোনো থানায় জানাতে পারেন, অপরাধ অন্য জায়গায় ঘটলেও — একে জিরো FIR বলে। পুলিশকে আপনাকে FIR-এর একটি কপি বিনামূল্যে দিতেই হবে। পুলিশ রাজি না হলে, আপনার অভিযোগ লিখে ডাকে পুলিশ সুপারের (SP) কাছে পাঠান। SP-ও কিছু না করলে, আপনি হলফনামা সহ ম্যাজিস্ট্রেটের কাছে আবেদন করতে পারেন।'
    },
    cyber_fraud: {
      q: 'অনলাইন বা UPI প্রতারণায় আমার টাকা চলে গেছে। কী করব?',
      a: 'এখনই 1930 নম্বরে কল করুন — এটি জাতীয় সাইবার ক্রাইম হেল্পলাইন, বিনামূল্যে, দিনরাত চালু থাকে। তাড়াতাড়ি জানালে টাকা অন্য জায়গায় সরিয়ে নেওয়া আটকাতে সাহায্য হয়। সঙ্গে cybercrime.gov.in ওয়েবসাইটে “Financial Fraud” অংশে অভিযোগ জানান।'
    },
    women: {
      q: 'কোনো মহিলা হিংসা বা হয়রানির শিকার হচ্ছেন। তিনি কোথায় সাহায্য পাবেন?',
      a: 'জরুরি অবস্থায় পুলিশ, দমকল বা অ্যাম্বুলেন্সের জন্য 112 নম্বরে ফোন করুন। বিনামূল্যের মহিলা হেল্পলাইন 181 নম্বরে দিনে বা রাতে যেকোনো সময় কল করুন। আপনি নিজের নাম গোপন রাখতে পারেন, আর এটি আপনাকে পুলিশ, ওয়ান স্টপ সেন্টার, হাসপাতাল বা আইনি সাহায্যের সঙ্গে যোগাযোগ করিয়ে দেয়। জাতীয় মহিলা কমিশনেরও একটি হেল্পলাইন আছে, 14490, আর তারা অনলাইনে অভিযোগও নেয়।'
    },
    consumer: {
      q: 'কোনো দোকান বা কোম্পানি আমাকে ঠকিয়েছে। কোথায় অভিযোগ করব?',
      a: 'জাতীয় উপভোক্তা হেল্পলাইন 1915 নম্বরে কল করুন (বিনামূল্যে, সকাল 8টা থেকে রাত 8টা), 8800001915 নম্বরে WhatsApp মেসেজ পাঠান, অথবা consumerhelpline.gov.in ওয়েবসাইটে অভিযোগ করুন। উপভোক্তা কমিশনে মামলা করতে চাইলে, e-Daakhil-এ অনলাইনে করতে পারেন।'
    },
    summons: {
      q: 'আমি আদালতের সমন পেয়েছি। কী করব?',
      a: 'সমনে বলা থাকে কোন তারিখে আপনাকে আদালতে আসতে হবে। আপনি যোগ্য হলে, মামলার যেকোনো পর্যায়ে বিনামূল্যে উকিল পেতে পারেন: 15100 নম্বরে কল করুন বা আপনার জেলা আদালতে আইনি পরিষেবা অফিসে যান। আপনার মামলা আর তার পরের তারিখ eCourts ওয়েবসাইট বা অ্যাপে দেখে নিতে পারেন।'
    },
    case_status: {
      q: 'আমার আদালতের মামলার অবস্থা (স্টেটাস) কীভাবে দেখব?',
      a: 'services.ecourts.gov.in ওয়েবসাইটে যান, বা eCourts সার্ভিসেস অ্যাপ ব্যবহার করুন, আর আপনার 16 সংখ্যার CNR নম্বর বা মামলার অন্য তথ্য দিয়ে খুঁজুন। এসএমএস-ও পাঠাতে পারেন: ECOURTS, তারপর একটি স্পেস, তারপর আপনার CNR নম্বর লিখে 9766899899 নম্বরে পাঠান।'
    },
    lok_adalat: {
      q: 'লোক আদালত কী?',
      a: 'লোক আদালত দুই পক্ষের সম্মতিতে মামলার নিষ্পত্তি করে। এখানে কোনো কোর্ট ফি লাগে না, আর আদালতে আগে থেকে চলা কোনো মামলা এখানে মিটে গেলে, আপনার দেওয়া কোর্ট ফি ফেরত দেওয়া হয়। এর সিদ্ধান্ত আদালতের ডিক্রির মতোই চূড়ান্ত, আর তা মানতেই হয়। এর বিরুদ্ধে কোনো আপিল করা যায় না।'
    },
    rti: {
      q: 'RTI কীভাবে করব?',
      a: 'কেন্দ্রীয় সরকারের অফিসের জন্য rtionline.gov.in ওয়েবসাইটে অনলাইনে আবেদন করুন। ফি ₹10; আপনি দারিদ্র্যসীমার নিচে থাকলে কোনো ফি লাগে না (আপনার BPL সার্টিফিকেট জুড়ে দিন)। অফিসারকে 30 দিনের মধ্যে উত্তর দিতে হবে, আর কারও জীবন বা স্বাধীনতার ব্যাপার হলে 48 ঘণ্টার মধ্যে। 30 দিনে উত্তর না এলে, পরের 30 দিনের মধ্যে বিনামূল্যে প্রথম আপিল করতে পারেন।'
    },
    grievance: {
      q: 'সরকারি অফিস আমার কাজ করছে না। কোথায় অভিযোগ করব?',
      a: 'pgportal.gov.in ওয়েবসাইটে CPGRAMS-এ অভিযোগ জানান — এটি দিনরাত খোলা থাকে (এর অ্যাপে আর UMANG-এও করা যায়)। 21 দিনের মধ্যে সমাধান করার লক্ষ্য রাখা হয়েছে। এখানে RTI-র বিষয়, আদালতের মামলা, ধর্মীয় বিষয় বা সরকারি কর্মচারীদের চাকরি সংক্রান্ত বিষয় নেওয়া হয় না।'
    }
  }
}
